import {Action} from 'react-fetching-library';
import {CompanyValidResponse} from './domain';
import {ServicesUrl} from '../../Config/UrlRuotes';
import {GetToken, MessageResponse} from '../Domain';

export const validateCompany:(company:string)=>Action<CompanyValidResponse> = (company) => {
    const urlRequest = `${ServicesUrl.company}/validate/${company}`;

    return {
        method: 'GET',
        endpoint: urlRequest
    };
};

export const validateMigrationToken:()=>Action<MessageResponse> = () => {
    const urlRequest = `${ServicesUrl.company}/migrations`;

    return {
        method: 'GET',
        endpoint: urlRequest,
        headers: {
            'Authorization-Token': GetToken()
        }
    };
};
